import Container from "../common/Container";
import SectionTitle from "../common/SectionTitle";
import "../../styles/ClientsMarquee.css";

const clientLogos = [
  { src: "/images/clients/1.png", alt: "Client 1" },
  { src: "/images/clients/2.png", alt: "Client 2" },
  { src: "/images/clients/3.png", alt: "Client 3" },
  { src: "/images/clients/4.png", alt: "Client 4" },
  { src: "/images/clients/5.png", alt: "Client 5" },
  { src: "/images/clients/1.png", alt: "Client 1" },
  { src: "/images/clients/2.png", alt: "Client 2" },
  { src: "/images/clients/3.png", alt: "Client 3" },
  { src: "/images/clients/4.png", alt: "Client 4" },
  { src: "/images/clients/5.png", alt: "Client 5" },
  
];

export default function ClientsMarquee() {
  const duplicatedLogos = [...clientLogos, ...clientLogos];

  return (
    <section id="clients" className="clients-section">
      <Container>
        <SectionTitle
          badge="Our Clients"
          title="Trusted By Leading Businesses"
          desc="Proud to work with organisations across Australia."
        />
      </Container>

      {/* The Wrapper handles the fading edge mask */}
      <div className="marquee-wrapper">
        <div className="clients-scroller-container" aria-label="Client logos">
          <div className="clients-track">
            {duplicatedLogos.map((logo, index) => (
              <div 
                key={index} 
                className="client-logo-card frosted-glass"
                // Hide duplicates from screen readers to avoid repetition
                aria-hidden={index >= clientLogos.length ? "true" : "false"}
              >
                <img
                  src={logo.src}
                  alt={logo.alt}
                  className="client-logo-img"
                  loading="lazy"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}